/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const referralLeaderboardEntrySchema = z.object({
  inviterUserId: z.string(),
  activatedCount: z.number(),
});

export const getReferralLeaderboardV1ResponseDataSchema = z.object({
  entries: z.array(referralLeaderboardEntrySchema),
});

export type IGetReferralLeaderboardV1ResponseData = z.infer<
  typeof getReferralLeaderboardV1ResponseDataSchema
>;

export const getReferralLeaderboardV1ResponseSchema = createApiResponseSchema(
  getReferralLeaderboardV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetReferralLeaderboardV1ResponseData>>;

export type IGetReferralLeaderboardV1Response = IAPI<IGetReferralLeaderboardV1ResponseData>;
